<div class="card-header">
  <div class="title-section">
    <h5 class="header-title">{{ model ? 'Editar' : 'Nueva' }} Tasa</h5>
  </div>
  <div class="button-section">
    <button
      mat-flat-button
      (click)="model ? update(form.value) : create(form.value)"
      class="{{ model ? 'btn-edit' : 'btn-success' }}"
      [disabled]="!form.valid || loading"
      appPermissionControl="P155B0003"
    >
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button mat-flat-button *ngIf="model" (click)="openCustomizables()" class="btn-search" appPermissionControl="P155B0006">
      <mat-icon>tune</mat-icon> 
      Customizables
    </button>
    <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P155B0002">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="model ? update(form.value) : create(form.value)" appPermissionControl="P155F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="text" formControlName="clave" class="form-control" [placeholder]="'Ingrese clave'" [readonly]="model" appPermissionControl="P155K0001" />
      <label>Clave Tasa</label>
      <small class="p-error" *ngIf="form.get('clave')?.errors?.required && form.get('clave')?.touched"> Campo requerido </small>
      <small class="p-error" *ngIf="form.get('clave')?.errors?.singleClave"> Clave en uso </small>
    </div>
    <div class="form-field">
      <input pInputText type="date" formControlName="fechaInicia" class="form-control" appPermissionControl="P155K0002" />
      <label>Fecha de Inicio</label>
      <small class="p-error" *ngIf="form.get('fechaInicia')?.errors?.required && form.get('fechaInicia')?.touched"> Campo requerido </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="descripcion" class="form-control" [placeholder]="'Ingrese descripción'" appPermissionControl="P155K0003" />
      <label>Descripción</label>
      <small class="p-error" *ngIf="form.get('descripcion')?.errors?.required && form.get('descripcion')?.touched"> Campo requerido </small>
    </div>
    <div class="form-field">
      <input pInputText type="number" formControlName="valor" class="form-control" [placeholder]="'Ingrese valor'" appPermissionControl="P155K0004" />
      <label>Tasa NMV / Factor</label>
      <small class="p-error" *ngIf="form.get('valor')?.errors?.required && form.get('valor')?.touched"> Campo requerido </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="formula" class="form-control" [placeholder]="'Ingrese fórmula'" appPermissionControl="P155K0005" />
      <label>Fórmula</label>
    </div>
    <ng-container *ngIf="model">
      <div class="form-field flex-grow-1">
        <input pInputText type="number" formControlName="simulatorValor" class="form-control" readonly appPermissionControl="P155K0006" />
        <label>Valor Simulador</label>
      </div>
      <div class="form-field flex-grow-1 mt-1">
        <button mat-flat-button type="button" color="primary" (click)="simulator()" class="btn-search" appPermissionControl="P155B0001">
          <mat-icon>calculate</mat-icon>
          Simulador
        </button>
      </div>
    </ng-container>
  </div>
</form>
